import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthSelectors } from '@shared/store/auth/auth.selectors';

export const hasAssignedPsychologistGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);

  return store.select(AuthSelectors.hasAssignedPsychologist);
};